export default "__VITE_PUBLIC_ASSET__10aea99b__"